import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { AuthProvider } from './contexts/AuthContext'
import { MaintenanceProvider } from './contexts/MaintenanceContext';
import './i18n/config'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MaintenanceProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </MaintenanceProvider>
  </React.StrictMode>,
)

console.log("🚩 App cargada - revisa si Tailwind funciona");
